import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { TableRow } from ".";

interface ITableProps {
  childTableData: any;
  columnsSchema: ColumnDef<any>[];
  tableEmptyComponent?: React.ReactNode;
  borderColor?: string;
  isHeaderSticky?: boolean;
  cellClassName?: string;
  isLoadingChildTable: boolean;
}

function ChildTable({
  childTableData,
  columnsSchema,
  isLoadingChildTable,
  tableEmptyComponent,
  borderColor = "border-extraLightGray",
  isHeaderSticky = false,
  cellClassName = "",
}: ITableProps) {
  const table = useReactTable({
    data: childTableData?.data?.data?.products ?? [],
    columns: columnsSchema,
    getCoreRowModel: getCoreRowModel(),
  });
  if (isLoadingChildTable) {
    return (
      <div className="h-20 w-[95%] mx-auto flex m-2 items-center justify-center animate-pulse rounded-xl bg-extraLightGray" />
    );
  }

  return (
    <div className="w-full min-w-0 p-3">
      <h4 className="mb-2 text-sm font-semibold text-slate-800">
        {childTableData?.companyName}
      </h4>
      <div className="w-full overflow-x-auto">
        <table className="w-full ">
          <thead className="h-10">
            {table?.getHeaderGroups()?.map((headerGroup) => (
              <tr
                className={`bg-offWhite ${isHeaderSticky && "sticky z-20 top-0"}`}
                key={headerGroup?.id}
              >
                {headerGroup?.headers?.map((header) => {
                  return (
                    <th
                      className={`font-semibold text-subHeading border ${borderColor} 
                  px-2 text-sm text-left  border-t-0 first:border-l-0  first:rounded-tl-lg
                  last:border-r-0  last:rounded-tr-lg z-10`}
                      key={header?.id}
                    >
                      <span>
                        {flexRender(
                          header?.column?.columnDef?.header,
                          header?.getContext()
                        )}
                      </span>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody className="z-5">
            {table?.getRowModel()?.rows?.map((row) => (
              <TableRow key={row.id}>
                {row.getVisibleCells()?.map((cell) => {
                  return (
                    <td
                      key={cell.id}
                      className={`border ${borderColor} ${cellClassName} first:border-l-0 last:border-r-0 text-sm font-semibold`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  );
                })}
              </TableRow>
            ))}
          </tbody>
        </table>
      </div>
      {table.getRowModel().rows.length === 0 && (
        <div className="flex items-center justify-center h-10 border-b border-extraLightGray rounded-lg ">
          {tableEmptyComponent || (
            <p className="font-medium text-sm">No data available to show!</p>
          )}
        </div>
      )}
    </div>
  );
}

export default ChildTable;
